import React from 'react';

function PhoneConfirmationCard(props: object & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="316"
      height="700"
      viewBox="0 0 316 700"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props as React.SVGProps<SVGSVGElement>)}
    >
      <rect
        x="152.798"
        y="6.4"
        width="291.2"
        height="612.8"
        rx="44.8"
        fill="white"
      />
      <rect
        x="152.798"
        y="6.4"
        width="291.2"
        height="612.8"
        rx="44.8"
        stroke="#313131"
        strokeWidth="12.8"
      />
      <path
        d="M177.401 74V55.824H181.19L186.591 70.7488L191.993 55.824H195.782V74H193.017V60.688L188.127 73.9744H185.055L180.166 60.688V74H177.401ZM204.739 74.3072C203.407 74.3072 202.255 74.0171 201.283 73.4368C200.327 72.8565 199.584 72.0288 199.055 70.9536C198.543 69.8784 198.287 68.624 198.287 67.1904C198.287 65.7568 198.543 64.5109 199.055 63.4528C199.584 62.3776 200.327 61.5499 201.283 60.9696C202.238 60.3723 203.365 60.0736 204.662 60.0736C205.891 60.0736 206.974 60.3637 207.913 60.944C208.852 61.5072 209.577 62.3264 210.089 63.4016C210.618 64.4768 210.883 65.7739 210.883 67.2928V67.984H201.103C201.172 69.3152 201.522 70.3136 202.153 70.9792C202.802 71.6448 203.672 71.9776 204.764 71.9776C205.566 71.9776 206.232 71.7899 206.761 71.4144C207.29 71.0389 207.657 70.5355 207.862 69.904L210.678 70.0832C210.319 71.3461 209.611 72.3701 208.553 73.1552C207.512 73.9232 206.24 74.3072 204.739 74.3072ZM201.103 65.936H208.015C207.93 64.7243 207.58 63.8283 206.966 63.248C206.368 62.6677 205.6 62.3776 204.662 62.3776C203.689 62.3776 202.887 62.6848 202.255 63.2992C201.641 63.8965 201.257 64.7755 201.103 65.936ZM218.368 74.3072C217.088 74.3072 216.004 74.1109 215.117 73.7184C214.247 73.3259 213.572 72.7883 213.095 72.1056C212.617 71.4059 212.344 70.6037 212.275 69.6992L215.066 69.5712C215.202 70.3221 215.527 70.9195 216.039 71.3632C216.551 71.8069 217.327 72.0288 218.368 72.0288C219.222 72.0288 219.896 71.8923 220.391 71.6192C220.886 71.3461 221.133 70.9109 221.133 70.3136C221.133 69.9893 221.048 69.7163 220.877 69.4944C220.723 69.2555 220.416 69.0592 219.955 68.9056C219.495 68.7349 218.812 68.5728 217.907 68.4192C216.559 68.1632 215.501 67.8645 214.733 67.5232C213.965 67.1819 213.419 66.7467 213.095 66.2176C212.77 65.6885 212.608 65.0485 212.608 64.2976C212.608 63.0517 213.069 62.0363 213.991 61.2512C214.929 60.4661 216.278 60.0736 218.035 60.0736C219.213 60.0736 220.203 60.2784 221.005 60.688C221.807 61.0805 222.43 61.6181 222.874 62.3008C223.335 62.9664 223.625 63.7173 223.744 64.5536L220.954 64.7072C220.868 64.2293 220.698 63.8197 220.442 63.4784C220.203 63.12 219.879 62.8469 219.469 62.6592C219.059 62.4544 218.573 62.352 218.01 62.352C217.139 62.352 216.491 62.5227 216.064 62.864C215.638 63.2053 215.424 63.6491 215.424 64.1952C215.424 64.6048 215.518 64.9376 215.706 65.1936C215.911 65.4496 216.235 65.6629 216.679 65.8336C217.122 65.9872 217.711 66.1237 218.445 66.2432C219.862 66.4821 220.971 66.7808 221.773 67.1392C222.575 67.4805 223.138 67.9072 223.463 68.4192C223.787 68.9312 223.949 69.5541 223.949 70.288C223.949 71.1413 223.71 71.8667 223.232 72.464C222.754 73.0613 222.097 73.5221 221.261 73.8464C220.425 74.1536 219.46 74.3072 218.368 74.3072ZM231.431 74.3072C230.151 74.3072 229.067 74.1109 228.18 73.7184C227.31 73.3259 226.635 72.7883 226.158 72.1056C225.68 71.4059 225.407 70.6037 225.338 69.6992L228.129 69.5712C228.265 70.3221 228.59 70.9195 229.102 71.3632C229.614 71.8069 230.39 72.0288 231.431 72.0288C232.285 72.0288 232.959 71.8923 233.454 71.6192C233.949 71.3461 234.196 70.9109 234.196 70.3136C234.196 69.9893 234.111 69.7163 233.94 69.4944C233.786 69.2555 233.479 69.0592 233.018 68.9056C232.558 68.7349 231.875 68.5728 230.97 68.4192C229.622 68.1632 228.564 67.8645 227.796 67.5232C227.028 67.1819 226.482 66.7467 226.158 66.2176C225.833 65.6885 225.671 65.0485 225.671 64.2976C225.671 63.0517 226.132 62.0363 227.054 61.2512C227.992 60.4661 229.341 60.0736 231.098 60.0736C232.276 60.0736 233.266 60.2784 234.068 60.688C234.87 61.0805 235.493 61.6181 235.937 62.3008C236.398 62.9664 236.688 63.7173 236.807 64.5536L234.017 64.7072C233.931 64.2293 233.761 63.8197 233.505 63.4784C233.266 63.12 232.942 62.8469 232.532 62.6592C232.122 62.4544 231.636 62.352 231.073 62.352C230.202 62.352 229.554 62.5227 229.127 62.864C228.701 63.2053 228.487 63.6491 228.487 64.1952C228.487 64.6048 228.581 64.9376 228.769 65.1936C228.974 65.4496 229.298 65.6629 229.742 65.8336C230.185 65.9872 230.774 66.1237 231.508 66.2432C232.925 66.4821 234.034 66.7808 234.836 67.1392C235.638 67.4805 236.201 67.9072 236.526 68.4192C236.85 68.9312 237.012 69.5541 237.012 70.288C237.012 71.1413 236.773 71.8667 236.295 72.464C235.817 73.0613 235.16 73.5221 234.324 73.8464C233.488 74.1536 232.523 74.3072 231.431 74.3072ZM243.336 74.3072C241.919 74.3072 240.784 73.9829 239.931 73.3344C239.095 72.6859 238.676 71.7728 238.676 70.5952C238.676 69.4176 239.026 68.5045 239.726 67.856C240.443 67.1904 241.544 66.7125 243.028 66.4224L247.713 65.5264C247.713 64.4683 247.466 63.6832 246.971 63.1712C246.476 62.6421 245.742 62.3776 244.769 62.3776C243.899 62.3776 243.216 62.5739 242.721 62.9664C242.226 63.3419 241.885 63.9051 241.697 64.656L238.907 64.4768C239.163 63.1115 239.794 62.0363 240.801 61.2512C241.825 60.4661 243.148 60.0736 244.769 60.0736C246.612 60.0736 248.012 60.5685 248.968 61.5584C249.94 62.5312 250.427 63.9051 250.427 65.68V70.9792C250.427 71.3035 250.478 71.5339 250.58 71.6704C250.7 71.7899 250.888 71.8496 251.144 71.8496H251.63V74C251.545 74.0171 251.408 74.0341 251.22 74.0512C251.033 74.0683 250.836 74.0768 250.632 74.0768C250.051 74.0768 249.548 73.9829 249.121 73.7952C248.712 73.6075 248.404 73.3003 248.2 72.8736C247.995 72.4299 247.892 71.8411 247.892 71.1072L248.174 71.2352C248.037 71.8325 247.739 72.3616 247.278 72.8224C246.834 73.2832 246.263 73.6501 245.563 73.9232C244.88 74.1792 244.138 74.3072 243.336 74.3072ZM243.771 72.1568C244.59 72.1568 245.29 72.0032 245.87 71.696C246.45 71.3717 246.903 70.928 247.227 70.3648C247.551 69.8016 247.713 69.1616 247.713 68.4448V67.5744L243.72 68.3424C242.9 68.496 242.32 68.7435 241.979 69.0848C241.655 69.4091 241.492 69.8272 241.492 70.3392C241.492 70.9195 241.689 71.3717 242.081 71.696C242.491 72.0032 243.054 72.1568 243.771 72.1568ZM258.788 78.1472C257.712 78.1472 256.765 77.9851 255.946 77.6608C255.127 77.3365 254.453 76.8757 253.924 76.2784C253.395 75.6981 253.036 75.0155 252.848 74.2304L255.664 74.0512C255.852 74.6144 256.176 75.0581 256.637 75.3824C257.115 75.7237 257.832 75.8944 258.788 75.8944C259.914 75.8944 260.776 75.6555 261.373 75.1776C261.988 74.6997 262.295 73.9744 262.295 73.0016V71.0304C261.971 71.7301 261.45 72.2848 260.733 72.6944C260.016 73.104 259.214 73.3088 258.327 73.3088C257.183 73.3088 256.168 73.0272 255.28 72.464C254.393 71.9008 253.702 71.1243 253.207 70.1344C252.712 69.1445 252.464 68.0011 252.464 66.704C252.464 65.3899 252.703 64.2379 253.181 63.248C253.676 62.2581 254.359 61.4816 255.229 60.9184C256.117 60.3552 257.115 60.0736 258.224 60.0736C259.197 60.0736 260.051 60.2955 260.784 60.7392C261.535 61.1829 262.073 61.7803 262.397 62.5312V60.3808H265.008V72.9248C265.008 74.0512 264.752 74.9984 264.24 75.7664C263.745 76.5515 263.029 77.1403 262.09 77.5328C261.168 77.9424 260.068 78.1472 258.788 78.1472ZM258.762 71.0048C259.82 71.0048 260.665 70.6208 261.296 69.8528C261.945 69.0848 262.278 68.0267 262.295 66.6784C262.312 65.7909 262.175 65.0315 261.885 64.4C261.595 63.7515 261.177 63.2565 260.631 62.9152C260.102 62.5568 259.479 62.3776 258.762 62.3776C257.653 62.3776 256.791 62.7701 256.176 63.5552C255.579 64.3232 255.28 65.3643 255.28 66.6784C255.28 68.0096 255.588 69.0677 256.202 69.8528C256.833 70.6208 257.687 71.0048 258.762 71.0048ZM273.704 74.3072C272.372 74.3072 271.22 74.0171 270.248 73.4368C269.292 72.8565 268.549 72.0288 268.02 70.9536C267.508 69.8784 267.252 68.624 267.252 67.1904C267.252 65.7568 267.508 64.5109 268.02 63.4528C268.549 62.3776 269.292 61.5499 270.248 60.9696C271.203 60.3723 272.33 60.0736 273.627 60.0736C274.856 60.0736 275.939 60.3637 276.878 60.944C277.817 61.5072 278.542 62.3264 279.054 63.4016C279.583 64.4768 279.848 65.7739 279.848 67.2928V67.984H270.068C270.137 69.3152 270.487 70.3136 271.118 70.9792C271.767 71.6448 272.637 71.9776 273.729 71.9776C274.531 71.9776 275.197 71.7899 275.726 71.4144C276.255 71.0389 276.622 70.5355 276.827 69.904L279.643 70.0832C279.284 71.3461 278.576 72.3701 277.518 73.1552C276.477 73.9232 275.205 74.3072 273.704 74.3072ZM270.068 65.936H276.98C276.895 64.7243 276.545 63.8283 275.931 63.248C275.333 62.6677 274.565 62.3776 273.627 62.3776C272.654 62.3776 271.852 62.6848 271.22 63.2992C270.606 63.8965 270.222 64.7755 270.068 65.936Z"
        fill="black"
      />
      <rect
        x="0.522762"
        y="123.726"
        width="44.9576"
        height="44.9576"
        rx="22.4788"
        fill="#FAFAFA"
      />
      <rect
        x="0.522762"
        y="123.726"
        width="44.9576"
        height="44.9576"
        rx="22.4788"
        stroke="#E5E5E5"
        strokeWidth="1.04552"
      />
      <path
        d="M30.323 136.797H15.8675C14.7176 136.797 13.7819 137.711 13.7819 138.834V142.687C13.7819 143.176 14.1876 143.574 14.69 143.574C15.1924 143.574 15.5981 143.177 15.5981 142.687V138.834C15.5981 138.689 15.719 138.569 15.8692 138.569H30.3248C30.4732 138.569 30.5958 138.687 30.5958 138.834V142.169C30.5958 142.245 30.563 142.317 30.5043 142.368L24.0163 147.968C23.6417 148.292 23.6054 148.851 23.9369 149.219C24.1164 149.418 24.3668 149.517 24.6171 149.517C24.8312 149.517 25.0453 149.445 25.2179 149.295L31.7059 143.695C32.1531 143.309 32.4103 142.752 32.4103 142.169V138.834C32.4086 137.711 31.4729 136.797 30.323 136.797Z"
        fill="url(#paint0_linear_10029_81649)"
      />
      <path
        d="M31.5005 148.147C30.9998 148.147 30.5924 148.543 30.5924 149.033V153.579C30.5924 153.724 30.4715 153.844 30.3213 153.844H15.738C15.5895 153.844 15.4669 153.726 15.4669 153.579V149.388C15.4669 149.327 15.4911 149.27 15.5308 149.222L16.1765 148.585L20.5789 144.285C20.6843 144.182 20.8552 144.182 20.9622 144.285L22.15 145.445C22.5039 145.791 23.0788 145.791 23.4328 145.445C23.7867 145.1 23.7867 144.538 23.4328 144.192L22.245 143.032C21.4318 142.238 20.1093 142.238 19.2962 143.032L14.2636 147.948C14.236 147.975 14.2101 148.005 14.1842 148.034L11.5979 150.588C11.2457 150.935 11.2492 151.497 11.6048 151.841C11.7809 152.011 12.0123 152.097 12.2419 152.097C12.475 152.097 12.7098 152.01 12.8876 151.834L13.6507 151.079V153.579C13.6507 154.702 14.5864 155.616 15.7362 155.616H30.3196C31.4694 155.616 32.4051 154.702 32.4051 153.579V149.033C32.4086 148.543 32.0029 148.147 31.5005 148.147Z"
        fill="url(#paint1_linear_10029_81649)"
      />
      {/* Background blur layer */}
      <foreignObject x="26.5488" y="91.2031" width="414.4" height="162.398">
        <div
          className="phone-confirmation-backdrop-blur"
          style={{
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            clipPath: 'url(#bgblur_0_10029_81649_clip_path)',
            height: '100%',
            width: '100%',
            pointerEvents: 'none',
          }}
        />
      </foreignObject>
      {/* Background rectangle */}
      <rect
        x="58.5488"
        y="123.203"
        width="350.4"
        height="98.4"
        rx="16.7284"
        fill="black"
        fillOpacity="0.51"
      />
      {/* 5 boxes - wrapped in foreignObject to create separate rendering context on iOS */}
      <foreignObject x="58.5488" y="123.203" width="350.4" height="98.4">
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
          }}
        >
          {/* Box 1 */}
          <div
            style={{
              position: 'absolute',
              left: '12.5469px',
              top: '27.188px',
              width: '41.821px',
              height: '43.912px',
              borderRadius: '4.1821px',
              backgroundColor: '#E0F0FF',
            }}
          />
          {/* Box 2 */}
          <div
            style={{
              position: 'absolute',
              left: '66.9142px',
              top: '27.188px',
              width: '41.821px',
              height: '43.912px',
              borderRadius: '4.1821px',
              backgroundColor: '#E0F0FF',
            }}
          />
          {/* Box 3 */}
          <div
            style={{
              position: 'absolute',
              left: '121.281px',
              top: '27.188px',
              width: '41.821px',
              height: '43.912px',
              borderRadius: '4.1821px',
              backgroundColor: '#E0F0FF',
            }}
          />
          {/* Box 4 */}
          <div
            style={{
              position: 'absolute',
              left: '175.648px',
              top: '27.188px',
              width: '41.821px',
              height: '43.912px',
              borderRadius: '4.1821px',
              backgroundColor: '#E0F0FF',
            }}
          />
          {/* Box 5 */}
          <div
            style={{
              position: 'absolute',
              left: '230.015px',
              top: '27.188px',
              width: '41.821px',
              height: '43.912px',
              borderRadius: '4.1821px',
              backgroundColor: '#E0F0FF',
            }}
          />
        </div>
      </foreignObject>
      <defs>
        <clipPath
          id="bgblur_0_10029_81649_clip_path"
          transform="translate(-26.5488 -91.2031)"
        >
          <rect
            x="58.5488"
            y="123.203"
            width="350.4"
            height="98.4"
            rx="16.7284"
          />
        </clipPath>
        <linearGradient
          id="paint0_linear_10029_81649"
          x1="21.5683"
          y1="133.968"
          x2="23.1752"
          y2="162.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F71FF8" />
          <stop offset="1" stopColor="#00B7FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10029_81649"
          x1="26.996"
          y1="157.028"
          x2="17.1732"
          y2="143.144"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#006CFF" />
          <stop offset="1" stopColor="#00B7FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PhoneConfirmationCard;
